import api from './auth'; // If you export your axios instance from auth.js

export const classifyImage = (formData) =>
    api.post('/api/classify', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });

export const getClassificationDetails = (id) =>
    api.get(`/api/classify/${id}/details`);

export const getClassificationHistory = () =>
    api.get('/api/classify/history');

export const submitClassificationFeedback = (data) =>
    api.post('/api/classify/feedback/submit', data);
